import { theme } from "../theme";

export function Spinner({ size = 18, color }: { size?: number; color?: string }) {
  return (
    <span
      role="status"
      aria-label="Loading"
      style={{
        display: "inline-block",
        width: size,
        height: size,
        borderRadius: "50%",
        border: `2px solid ${color ?? theme.color.border}`,
        borderTopColor: color ?? theme.color.accent,
        animation: "spin 0.7s linear infinite",
        flexShrink: 0,
      }}
    />
  );
}

export function LoadingBlock({ label = "Loading…" }: { label?: string }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flex: 1,
        gap: 10,
        color: theme.color.subtle,
        fontSize: 13,
        padding: 40,
      }}
    >
      <Spinner />
      <span>{label}</span>
    </div>
  );
}

export function ErrorBlock({ message, onRetry }: { message: string; onRetry?: () => void }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        flex: 1,
        gap: 12,
        padding: 40,
      }}
    >
      <span style={{ fontSize: 13, color: theme.color.dangerText }}>{message}</span>
      {onRetry && (
        <button
          onClick={onRetry}
          style={{
            background: "none",
            border: `1px solid ${theme.color.borderStrong}`,
            borderRadius: 3,
            padding: "7px 16px",
            fontSize: 12,
            color: theme.color.muted,
            cursor: "pointer",
          }}
        >
          Try again
        </button>
      )}
    </div>
  );
}
